// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../writer-core-master/Product/ItSymphony.Writer.Web/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../writer-core-master/Product/ItSymphony.Writer.Web/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.reply-message-panel-cell {
    padding: 0 0 10px 0;
}

.reply-message-panel {
    position: relative;
    width: 85%;
    box-sizing: border-box;
    padding: 6px 48px 6px 10px;
    border-left: 3px solid #777777;
    border-bottom: 1px solid #d9dfe5;
    background: #f8fafb;
    border-radius:3px;
}

.reply-message-panel__body {
    min-width: 0;
    width: 100%;
}

.reply-message-panel__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    margin-bottom: 5px;
}

.reply-message-panel__title {
    font-size: 16px;
    line-height: 16px;
    font-weight: 700;
    color: black;
    white-space: nowrap;
}

.reply-message-panel__close {
    position: absolute;
    right: 5px;
    width: 22px;
    height: 22px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    border-radius: 50%;
    color: #8a8a8a;
}

    .reply-message-panel__close:hover {
        background: rgba(0, 0, 0, 0.05);
        color: #444;
    }

    .reply-message-panel__close i {
        font-size: 20px;
        line-height: 20px;
    }

.reply-message-panel__text {
    max-width: 70rem;
    font-size: 14px;
    color: #666;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    text-align:left;
}
`, "",{"version":3,"sources":["webpack://./src/app/chat/reply-message-panel/ReplyMessagePanel.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,sBAAsB;IACtB,0BAA0B;IAC1B,8BAA8B;IAC9B,gCAAgC;IAChC,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,QAAQ;IACR,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,kBAAkB;IAClB,cAAc;AAClB;;IAEI;QACI,+BAA+B;QAC/B,WAAW;IACf;;IAEA;QACI,eAAe;QACf,iBAAiB;IACrB;;AAEJ;IACI,gBAAgB;IAChB,eAAe;IACf,WAAW;IACX,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;IACvB,eAAe;AACnB","sourcesContent":[".reply-message-panel-cell {\r\n    padding: 0 0 10px 0;\r\n}\r\n\r\n.reply-message-panel {\r\n    position: relative;\r\n    width: 85%;\r\n    box-sizing: border-box;\r\n    padding: 6px 48px 6px 10px;\r\n    border-left: 3px solid #777777;\r\n    border-bottom: 1px solid #d9dfe5;\r\n    background: #f8fafb;\r\n    border-radius:3px;\r\n}\r\n\r\n.reply-message-panel__body {\r\n    min-width: 0;\r\n    width: 100%;\r\n}\r\n\r\n.reply-message-panel__header {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n    gap: 8px;\r\n    margin-bottom: 5px;\r\n}\r\n\r\n.reply-message-panel__title {\r\n    font-size: 16px;\r\n    line-height: 16px;\r\n    font-weight: 700;\r\n    color: black;\r\n    white-space: nowrap;\r\n}\r\n\r\n.reply-message-panel__close {\r\n    position: absolute;\r\n    right: 5px;\r\n    width: 22px;\r\n    height: 22px;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    cursor: pointer;\r\n    border-radius: 50%;\r\n    color: #8a8a8a;\r\n}\r\n\r\n    .reply-message-panel__close:hover {\r\n        background: rgba(0, 0, 0, 0.05);\r\n        color: #444;\r\n    }\r\n\r\n    .reply-message-panel__close i {\r\n        font-size: 20px;\r\n        line-height: 20px;\r\n    }\r\n\r\n.reply-message-panel__text {\r\n    max-width: 70rem;\r\n    font-size: 14px;\r\n    color: #666;\r\n    white-space: nowrap;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n    text-align:left;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
